var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdplansIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe70d",
    d: "M245 11C109.69 11 0 120.69 0 256c0 86.543 44.874 162.601 112.621 206.187l.825-.659-21.443-58.911 58.498-21.292 32.83 90.198a6.51 6.51 0 0 0 6.098 4.271l18.97-.436a4.506 4.506 0 0 1 4.218 2.954l7.428 20.411 1.484 1.15A247.033 247.033 0 0 0 245 501c135.31 0 245-109.69 245-245S380.31 11 245 11z",
    opacity: 1,
    "data-original": "#fed402",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 256,
    r: 177,
    fill: "#ebd400",
    opacity: 1,
    "data-original": "#fac600",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 256,
    r: 116,
    fill: "#e8b800",
    opacity: 1,
    "data-original": "#e8b800",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.5,
    cy: 102.5,
    r: 83.5,
    fill: "#8783d1",
    opacity: 1,
    "data-original": "#af66da",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6460ba",
    d: "M393 102.5c0-37.771 25.086-69.669 59.5-79.982a83.48 83.48 0 0 0-24-3.518c-46.116 0-83.5 37.384-83.5 83.5s37.384 83.5 83.5 83.5a83.48 83.48 0 0 0 24-3.518C418.086 172.169 393 140.271 393 102.5z",
    opacity: 1,
    "data-original": "#9857bd",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.448 76.267h70.104a5 5 0 0 0 5-5v-5a5 5 0 0 0-5-5h-70.104a5 5 0 0 0-5 5v5a5 5 0 0 0 5 5zM474 95h-91a5 5 0 0 0-5 5v5a5 5 0 0 0 5 5h91a5 5 0 0 0 5-5v-5a5 5 0 0 0-5-5zM463.552 128.733h-70.104a5 5 0 0 0-5 5v5a5 5 0 0 0 5 5h70.104a5 5 0 0 0 5-5v-5a5 5 0 0 0-5-5z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#596c76",
    d: "m32.797 317.016-25.901 9.427c-5.437 1.979-8.24 7.99-6.261 13.427l16.964 46.608c1.979 5.437 7.99 8.24 13.427 6.261l25.901-9.427z",
    opacity: 1,
    "data-original": "#596c76",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#465a61",
    d: "m28.967 365.377-15.095-41.473-6.976 2.539c-5.437 1.979-8.24 7.99-6.261 13.427l16.964 46.608c1.979 5.437 7.99 8.24 13.427 6.261l24.869-9.052-5.452-14.979-8.049 2.93c-5.437 1.979-11.449-.824-13.427-6.261z",
    opacity: 1,
    "data-original": "#465a61",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596c76",
    d: "m150.066 380.419 18.473 50.754 14.598-5.313a10.476 10.476 0 0 0 6.828-11.007l-5.254-47.044z",
    opacity: 1,
    "data-original": "#596c76",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d9ca8",
    d: "M213.555 477.972a5.49 5.49 0 0 0-5.286-3.611l-18.713.432a5.49 5.49 0 0 1-5.286-3.611l-33.172-91.138-60.377 21.975 21.899 60.168a243.53 243.53 0 0 0 108.906 37.688z",
    opacity: 1,
    "data-original": "#8d9ca8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7a8c98",
    d: "m116.627 392.59-25.906 9.429 21.899 60.168a244.321 244.321 0 0 0 36.351 19.269z",
    opacity: 1,
    "data-original": "#7a8c98",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m282.314 115.803-109.593 127.95 38.486 105.739 166.198 27.57z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2fbff",
    d: "m226.062 307.994-32.316-88.788-21.026 24.547 38.486 105.739 166.198 27.57-14.836-40.761-127.985-21.231a10.981 10.981 0 0 1-8.521-7.076z",
    opacity: 1,
    "data-original": "#f2fbff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d9ca8",
    d: "m397.264 198.914-46.099-7.647 30.476 83.731 30.399-35.49a10.477 10.477 0 0 0 1.888-10.398l-8.533-23.445a10.476 10.476 0 0 0-8.131-6.751z",
    opacity: 1,
    "data-original": "#8d9ca8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7a8c98",
    d: "M404.744 204.246a10.47 10.47 0 0 1-2.302 8.893l-29.579 34.533 9.597 26.368 29.579-34.533a10.477 10.477 0 0 0 1.888-10.398l-8.533-23.445c-.18-.493-.403-.964-.65-1.418z",
    opacity: 1,
    "data-original": "#7a8c98",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5694",
    d: "M210.48 359.599 81.002 406.726c-8.155 2.968-17.172-1.237-20.14-9.392l-34.064-93.59c-2.968-8.155 1.237-17.172 9.391-20.14l129.478-47.126a5.238 5.238 0 0 1 6.713 3.13l41.23 113.277a5.238 5.238 0 0 1-3.13 6.714z",
    opacity: 1,
    "data-original": "#fe5694"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd3581",
    d: "m104.405 381.486-34.064-93.59c-2.968-8.155 1.237-17.172 9.392-20.14l-43.544 15.849c-8.155 2.968-12.36 11.985-9.391 20.14l34.064 93.59c2.968 8.155 11.985 12.36 20.14 9.392l43.544-15.849c-8.156 2.967-17.173-1.237-20.141-9.392z",
    opacity: 1,
    "data-original": "#fd3581",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5694",
    d: "M419.153 390.904 390.865 401.2a5.49 5.49 0 0 1-7.037-3.281l-110-302.221a5.49 5.49 0 0 1 3.281-7.037l28.288-10.296a5.49 5.49 0 0 1 7.037 3.281l109.999 302.22a5.49 5.49 0 0 1-3.28 7.038z",
    opacity: 1,
    "data-original": "#fe5694"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd3581",
    d: "M401.369 391.534 291.37 89.314a5.49 5.49 0 0 1 3.281-7.037l-17.542 6.385a5.49 5.49 0 0 0-3.281 7.037l109.999 302.22a5.49 5.49 0 0 0 7.037 3.281l17.542-6.385a5.49 5.49 0 0 1-7.037-3.281z",
    opacity: 1,
    "data-original": "#fd3581",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.344,
    cy: 143.656,
    r: 68.656,
    fill: "#5dd39e",
    opacity: 1,
    "data-original": "#05e39c",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.344,
    cy: 143.656,
    r: 48.54,
    fill: "#0ed290",
    opacity: 1,
    "data-original": "#0ed290",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c285",
    d: "M118.623 143.656c0-21.79 14.359-40.227 34.13-46.365a48.538 48.538 0 0 0-14.41-2.175c-26.808 0-48.54 21.732-48.54 48.54s21.732 48.54 48.54 48.54c5.018 0 9.857-.762 14.41-2.175-19.771-6.138-34.13-24.575-34.13-46.365z",
    opacity: 1,
    "data-original": "#00c285",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M159.059 137.901h-41.431a5.754 5.754 0 0 1 0-11.508h41.431a5.754 5.754 0 0 1 0 11.508zM159.059 160.919h-41.431a5.754 5.754 0 0 1 0-11.508h41.431a5.754 5.754 0 0 1 0 11.508z",
    opacity: 1,
    "data-original": "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdplansIcon);
export default __webpack_public_path__ + "static/media/adplans-icon.043a4826ffaac4703fdfafd660b58981.svg";
export { ForwardRef as ReactComponent };